import React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import withStyles from "@material-ui/core/styles/withStyles";
import Snackbar from "@material-ui/core/Snackbar";

import AccommodationCard from "../../../components/ui/AccommodationCard.jsx";
import { palette, typography } from "../../../theme/brand";

import CustomNotification from "../../LandingPage/Sections/CustomNotification";

const styles = {
  heading: {
    color: palette.textPrimary,
    fontFamily: typography.fontFamilyDisplay,
    fontWeight: 700,
    margin: "0 0 24px"
  }
};

export class SectionFiltered extends React.Component {
  totalAccom = 0;

  constructor(props) {
    super(props);

    this.state = {
      openNotification: false,
      variantNotification: "",
      messageNotification: ""
    };
  }

  componentDidMount() {
    this.handleClickNotification(
      "Alojamientos filtrados exitosamente",
      "success"
    );
  }

  handleClickNotification = (messageNotification, variantNotification) => {
    this.setState({
      openNotification: true,
      messageNotification,
      variantNotification
    });
  };

  handleCloseNotification = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    this.setState({ openNotification: false });
  };

  render() {
    const { classes, filtersReducer } = this.props;
    const { filteredAccommodations } = filtersReducer;

    this.totalAccom = filteredAccommodations.length;

    return (
      <div>
        <h2 className={classes.heading}>
          {this.totalAccom} Alojamientos encontrados:
        </h2>

        <Snackbar
          anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
          open={this.state.openNotification}
          autoHideDuration={6000}
          onClose={this.handleCloseNotification}
        >
          <CustomNotification
            onClose={this.handleCloseNotification}
            variant={this.state.variantNotification}
            message={this.state.messageNotification}
          />
        </Snackbar>

        {filteredAccommodations.map(accomm => (
          <AccommodationCard accommodation={accomm} key={accomm._id} />
        ))}
      </div>
    );
  }
}

SectionFiltered.propTypes = {
  classes: PropTypes.object.isRequired,
  filtersReducer: PropTypes.object
};

const mapStateToProps = state => ({
  filtersReducer: state.filtersReducer
});

export const StyledSectionFiltered = withStyles(styles)(SectionFiltered);

export default connect(mapStateToProps, null)(StyledSectionFiltered);



// WEBPACK FOOTER //
// ./src/views/AccommodationsPage/Sections/SectionFiltered.jsx